import { nachladen } from '../../lib/videoNames'
import type { TerrainStart } from './terrainGround'

/**
 * The relief's two early steps (1.130.0), in a file that loads no MapLibre
 * itself -- whoever never turns the switch on loads none.
 *
 * From use, on the iPad: before the bar of a film with relief ran, three
 * waits stood one after the other -- the server reading the day, the module
 * (some 800 KB), the style from OpenFreeMap. The module is our own server
 * and needs nothing but the switch; the style needs the build, not the day.
 */
const load = () => import('./terrainGround')

/** Fetches the module once the switch is on -- our own server only, nothing goes out. */
export function preloadTerrain(): void {
  void load().catch(() => {})
}

/**
 * Begins the map at the tap: the style goes out while the server reads the
 * day. The request leaves on the build with the switch on, as the privacy
 * notes say -- a second or two earlier, nothing more. Whoever takes it
 * closes it (`TerrainStart.close()` may be called twice).
 */
export function beginTerrain(tap: number): Promise<TerrainStart> {
  const start = nachladen(load).then((m) => m.startTerrain(tap))
  start.catch(() => {})
  return start
}
